module.exports = "//static.hsappstatic.net/ui-addon-upgrades/static-9.14404/js/img/MarketingHub_Icon.svg"